export const ar = {
    movementSchedule: {
    pageTitle: 'جدول الحركات',
    pageSubtitle: 'تتبع حركات الحجاج وعدادات التنازلي',
    buttons: {
      estimatedTimes: 'الأوقات المقدرة',
      defaultSchedule: 'الجدول الافتراضي'
    },
    stats: {
      todayMovements: 'حركات اليوم',
      completedMovements: 'الحركات المكتملة',
      upcomingMovements: 'الحركات القادمة',
      completionRate: 'معدل الإنجاز'
    },
    movementTypes: {
      arrival: 'قدوم الحجاج',
      departure: 'رحيل الحجاج',
      hotelTransfer: 'تحرك بين الفنادق',
      madinahTransfer: 'تحرك إلى المدينة',
      campDeparture: 'الذهاب إلى المخيم',
      campReturn: 'العودة من المخيم'
    },
    defaultSchedules: {
      campDeparture: 'موعد الذهاب الى المخيم',
      campReturn: 'موعد الرجوع من المخيم',
      hotelTransfer: 'وقت تحرك الفنادق'
    },
    errors: {
      loadFailed: 'فشل تحميل الحركات'
    }
  },
  movementTable: {
headers: {
type: 'نوع الحركة',
from: 'من',
to: 'إلى',
date: 'تاريخ التحرك',
time: 'وقت التحرك',
countdown: 'الوقت المتبقي',
pilgrims: 'عدد الحجاج',
actions: 'الإجراءات'
},
actions: {
viewDetails: 'عرض التفاصيل'
},
movementCount: 'تحرك'
},
common: {
pagination: {
page: 'صفحة',
of: 'من'
}
},
  movementExport: {
    sheetName: 'تفاصيل التحركات',
    exportError: 'فشل في تصدير التحركات',
    headers: {
      type: 'نوع التحرك',
      date: 'تاريخ التحرك',
      time: 'وقت التحرك',
      from: 'من',
      city: 'المدينة',
      to: 'إلى',
      name: 'اسم الحاج',
      passport: 'رقم الجواز',
      gender: 'الجنس',
      country: 'الدولة',
      package: 'الباقة',
      mobile: 'رقم الجوال',
      arrival: 'وقت الوصول المتوقع'
    }
  },
  movementTypes: {
    arrival: 'قدوم الحجاج',
    departure: 'رحيل الحجاج',
    hotelTransfer: 'تحرك بين الفنادق',
    campDeparture: 'الذهاب للمخيم',
    campReturn: 'العودة من المخيم',
    hotelTransferMadinah: 'تحرك للمدينة'
  },
  cities: {
    makkah: 'مكة المكرمة',
    madinah: 'المدينة المنورة',
    jeddah: 'جدة'
  },
movementDetails: {
    title: 'تفاصيل التحرك',
    pilgrimsCount: 'عدد الحجاج',
    date: 'التاريخ',
    departureTime: 'وقت التحرك',
    arrivalTime: 'وقت الوصول المتوقع',
    from: 'من',
    to: 'إلى',
    exportButton: 'تصدير التفاصيل',
    pilgrim: 'الحاج',
    passportNumber: 'رقم الجواز',
    gender: 'الجنس',
    country: 'الدولة',
    package: 'الباقة',
    mobileNumber: 'رقم الجوال',
    exportSuccess: 'تم تصدير التفاصيل بنجاح',
    exportError: 'فشل في تصدير التفاصيل'
  },
movements: {
    searchPlaceholder: 'بحث باسم التحرك أو الموقع...',
    allMovements: 'كل التحركات',
    arrival: 'قدوم الحجاج',
    hotelTransfer: 'تحرك بين الفنادق',
    campDeparture: 'الذهاب للمخيم',
    campReturn: 'العودة من المخيم',
    departure: 'رحيل الحجاج',
    allCitiesFrom: 'كل المدن (من)',
    allCitiesTo: 'كل المدن (إلى)',
    dateRange: 'تاريخ التحرك',
    timeRange: 'وقت التحرك',
    pilgrimsCount: 'عدد الحجاج',
    from: 'من',
    to: 'إلى',
    export: 'تصدير التحركات',
    activeFilters: 'الفلاتر النشطة',
    search: 'بحث',
    date: 'التاريخ',
    clearFilters: 'مسح الفلاتر',
    exportSuccess: 'تم تصدير تفاصيل التحركات بنجاح',
    exportError: 'فشل في تصدير تفاصيل التحركات'
  },

   passportVisa: {
    pageTitle: 'جوازات السفر وتأشيرات الحج',
    pageSubtitle: 'إدارة وثائق جوازات السفر والتأشيرات للحجاج',
    downloadAllZip: 'تحميل الكل كملف مضغوط',
    creatingZip: 'جارٍ إنشاء الملف المضغوط...',
    exportStatus: 'حالة التصدير',
    exporting: 'جارٍ التصدير...',
    searchPlaceholder: 'ابحث بالاسم أو رقم الجواز أو المرشد أو المنظم...',
    allOrganizers: 'جميع المنظمين',
    allDocumentTypes: 'جميع أنواع الوثائق',
    passportOnly: 'جواز السفر فقط',
    visaOnly: 'التأشيرة فقط',
    allStatuses: 'جميع الحالات',
    complete: 'مكتمل',
    missing: 'مفقود',
    activeFilters: 'الفلاتر النشطة:',
    search: 'بحث',
    organizer: 'المنظم',
    status: 'الحالة',
    documentType: 'نوع الوثيقة',
    loadingStatuses: 'جارٍ تحميل حالات الوثائق...',
    documentsByCountry: 'الوثائق حسب الدولة',
    documentsByOrganizer: 'الوثائق حسب المنظم',
    noDataAvailable: 'لا توجد بيانات متاحة',
    country: 'الدولة',
    total: 'الإجمالي',
    pilgrim: 'الحاج',
    guideAndOrganizer: 'المرشد والمنظم',
    document: 'الوثيقة',
    type: 'النوع',
    actions: 'الإجراءات',
    uploaded: 'تم الرفع',
    notUploaded: 'غير مرفوع',
    viewDocument: 'عرض الوثيقة',
    upload: 'رفع',
    view: 'عرض',
    noDocumentsMatch: 'لا توجد وثائق تطابق معايير البحث',
    noDocumentsAvailable: 'لا توجد وثائق متاحة',
    showing: 'عرض',
    of: 'من',
    documents: 'وثيقة',
    loadingPilgrimData: 'جارٍ تحميل بيانات الحجاج...',
    previous: 'السابق',
    next: 'التالي',
    page: 'الصفحة',
    exportSuccess: 'تم تصدير البيانات بنجاح',
    exportError: 'فشل تصدير البيانات',
    downloadSuccess: 'تم تنزيل الوثائق بنجاح',
    downloadError: 'فشل إنشاء ملف مضغوط',
    uploadSuccess: (type: string) => `تم رفع ${type} بنجاح`,
    uploadError: 'فشل رفع الوثيقة',
    failedToLoadStatuses: 'فشل تحميل حالات الوثائق',
    deleteSuccess: 'تم حذف الوثيقة بنجاح',
    deleteError: 'فشل حذف الوثيقة'
  },
  adminStats: {
    title: 'إحصائيات جميع المنظمين',
    totalPilgrims: 'إجمالي الحجاج',
    totalAmount: 'إجمالي المبلغ',
    totalBonuses: 'إجمالي المكافآت',
    pendingPilgrims: 'حجاج قيد الانتظار'
  },
  organizerFinanceconfigure: {
    configTable: {
      title: 'إعدادات المالية',
      addTitle: 'إضافة إعداد جديد'
    },
    tableHeaders: {
      organizer: 'المنظم',
      baseAmount: 'المبلغ الأساسي',
      bonusAmount: 'مبلغ المكافأة',
      notOwnerAmount: 'مبلغ غير المالك',
      actions: 'الإجراءات'
    },
    labels: {
      organizer: 'المنظم',
      baseAmount: 'المبلغ الأساسي',
      bonusAmount: 'مبلغ المكافأة',
      notOwnerAmount: 'مبلغ غير المالك',
      default: 'افتراضي'
    },
    placeholders: {
      selectOrganizer: 'اختر منظمًا'
    },
    actions: {
      addConfig: 'إضافة إعداد مخصص'
    },
    success: {
      saveConfig: 'تم حفظ الإعداد بنجاح',
      deleteConfig: 'تم حذف الإعداد بنجاح',
      addConfig: 'تمت إضافة الإعداد الجديد بنجاح'
    },
    errors: {
      loadConfigs: 'فشل تحميل إعدادات المالية',
      saveConfig: 'فشل حفظ الإعداد',
      deleteConfig: 'فشل حذف الإعداد',
      deleteDefault: 'لا يمكن حذف الإعداد الافتراضي',
      selectOrganizer: 'الرجاء اختيار منظم',
      configExists: 'الإعداد موجود بالفعل لهذا المنظم',
      addConfig: 'فشل إضافة الإعداد'
    },
    loading: {
      configs: 'جاري تحميل الإعدادات...'
    }
  },
  commonconfigur: {
    actions: {
      cancel: 'إلغاء',
      save: 'حفظ',
      refresh: 'تحديث'
    }
  },
  accommodationChart: {
    checkInOutTitle: 'جدول الوصول والمغادرة',
    loadData: 'تحميل البيانات',
    export: 'تصدير البيانات',
    exportSuccess: 'تم تصدير البيانات بنجاح',
    exportError: 'فشل تصدير البيانات',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات متاحة',
    clickToLoad: 'انقر فوق تحميل البيانات لعرض الإحصائيات',
    loadError: 'فشل تحميل البيانات',
    checkIn: 'الوصول',
    checkOut: 'المغادرة',
    myCheckIn: 'وصولي',
    myCheckOut: 'مغادرتي',
    accommodated: 'المستضافون',
    myAccommodated: 'مستضافيّ',
    totalCheckIns: 'إجمالي الوصول',
    totalCheckOuts: 'إجمالي المغادرة',
    totalAccommodated: 'إجمالي المستضافين',
    myTotalAccommodated: 'إجمالي مستضافيّ',
    peakOn: 'الذروة في',
    yours: 'خاصتك'
  },
  roomTypesChart: {
    all: 'كل أنواع الغرف',
    double: 'ثنائي',
    triple: 'ثلاثي',
    quadruple: 'رباعي'
  },
  bulkLinkStatus: {
    title: 'نتائج الربط بالجملة',
    backToGuide: 'العودة إلى صفحة المرشد',
    export: 'تصدير النتائج',
    processing: 'جارٍ معالجة الملف...',
    rowsProcessed: 'تمت معالجة الصفوف',
    totalProcessed: 'إجمالي المعالجة',
    successful: 'ناجح',
    failed: 'فشل',
    successRate: 'معدل النجاح',
    identifier: 'المعرف',
    pilgrimName: 'اسم الحاج',
    guide: 'المرشد',
    status: 'الحالة',
    errors: 'الأخطاء',
    statusSuccess: 'نجاح',
    statusError: 'فشل',
    statusProcessing: 'جارٍ المعالجة',
  },
  bulkLink: {
    validation: {
      invalidIdentifierType: 'نوع المعرف غير صالح',
      identifierRequired: 'المعرف مطلوب',
      guideRequired: 'اسم المرشد مطلوب',
      pilgrimNotFound: 'الحاج غير موجود',
      processingInProgress: 'جارٍ معالجة الحاج',
      duplicatePilgrim: 'الحاج موجود أكثر من مرة في الملف',
      guideNotFound: 'المرشد غير موجود',
    },
  },
  guidesList: {
    deleteSuccess: 'تم حذف المرشد بنجاح',
    deleteError: 'فشل في حذف المرشد',
    deleteTitle: 'حذف المرشد',
    deleteMessage: 'هل أنت متأكد من حذف المرشد',
    confirmDelete: 'حذف',
    cancelDelete: 'إلغاء',
    headers: {
      guide: 'المرشد',
      email: 'البريد الإلكتروني',
      organizer: 'المنظم التابع له',
      password: 'كلمة المرور',
      actions: 'الإجراءات',
    },
  },
  organizersList: {
    deleteSuccess: 'تم حذف المنظم بنجاح',
    deleteError: 'فشل في حذف المنظم',
    deleteTitle: 'حذف المنظم',
    deleteMessage: 'هل أنت متأكد من حذف المنظم',
    confirmDelete: 'حذف',
    cancelDelete: 'إلغاء',
    headers: {
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      actions: 'الإجراءات',
    },
  },
  editGuideModal: {
    title: 'تعديل بيانات المرشد',
    requiredFieldsError: 'جميع الحقول مطلوبة',
    updateSuccess: 'تم تحديث بيانات المرشد بنجاح',
    updateError: 'فشل في تحديث بيانات المرشد',
  },
  editOrganizerModal: {
    title: 'تعديل بيانات المنظم',
    requiredFieldsError: 'الاسم مطلوب',
    updateSuccess: 'تم تحديث بيانات المنظم بنجاح',
    updateError: 'فشل في تحديث بيانات المنظم',
  },
  guidesPage: {
    title: 'المرشدين',
    organizerDescription: 'إدارة المرشدين المعينين لك.',
    adminDescription: 'إدارة جميع المرشدين في النظام.',
    addGuideButton: 'إضافة مرشد',
  },
  organizersPage: {
    title: 'المنظمين',
    addOrganizer: 'إضافة منظم جديد',
  },
  organizerForm: {
    fields: {
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
    },
    validation: {
      required: 'هذا الحقل مطلوب',
      emailInvalid: 'البريد الإلكتروني غير صالح',
      passwordLength: 'يجب أن تكون كلمة المرور على الأقل 6 أحرف',
      passwordsNotMatch: 'كلمات المرور غير متطابقة',
    },
    buttons: {
      cancel: 'إلغاء',
      save: 'حفظ',
      saving: 'جاري الحفظ...',
    },
  },
  editRoomsButton: {
    title: 'تعديل الغرف',
    label: 'تعديل الغرف',
  },
  guideRow: {
    undefinedOrganizer: 'غير محدد',
    copyEmailSuccess: 'تم نسخ البريد الإلكتروني',
    copyPasswordSuccess: 'تم نسخ كلمة المرور',
    copyError: 'فشل في النسخ',
    emailLabel: 'البريد الإلكتروني:',
    passwordLabel: 'كلمة المرور:',
    resetPassword: 'تغيير كلمة المرور',
    delete: 'حذف',
    edit: 'تعديل',
    copyEmail: 'نسخ البريد الإلكتروني',
    copyPassword: 'نسخ كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
  },
  organizerRow: {
    copyEmailSuccess: 'تم نسخ البريد الإلكتروني',
    copyPasswordSuccess: 'تم نسخ كلمة المرور',
    copyError: 'فشل في النسخ',
    emailLabel: 'البريد الإلكتروني:',
    passwordLabel: 'كلمة المرور:',
    resetPassword: 'تغيير كلمة المرور',
    delete: 'حذف',
    edit: 'تعديل',
    copyEmail: 'نسخ البريد الإلكتروني',
    copyPassword: 'نسخ كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
  },

  verificationWizardPage: {
    errors: {
      checkVerification: 'فشل في التحقق من حالة التحقق',
      userNotFound: 'لم يتم العثور على معلومات المستخدم',
      verificationFailed: 'فشل في إتمام التحقق',
    },
    success: {
      verificationSubmitted: 'تم إرسال التحقق بنجاح',
    },
  },
  wizardProgress: {
    steps: {
      terms: 'الشروط',
      info: 'المعلومات',
      contract: 'العقد',
      bank: 'معلومات البنك',
    },
  },
  bankStep: {
    headers: {
      bankInformation: 'معلومات البنك',
    },
    labels: {
      bankName: 'اسم البنك',
      accountNumber: 'رقم الحساب',
      swiftCode: 'رمز SWIFT / BIC',
      bankBranch: 'فرع البنك',
      ifscCode: 'رمز RTGS / NEFT / IFSC',
    },
    placeholders: {
      bankName: 'أدخل اسم البنك',
      accountNumber: 'أدخل رقم حسابك',
      swiftCode: 'مثال: BOFAUS3N',
      bankBranch: 'أدخل اسم الفرع',
      ifscCode: 'مثال: ABCD0123456',
    },
    errors: {
      bankNameRequired: 'اسم البنك مطلوب',
      accountNumberInvalid: 'صيغة رقم الحساب غير صالحة (10-20 رقم)',
      swiftCodeInvalid: 'صيغة رمز SWIFT / BIC غير صالحة',
      bankBranchRequired: 'اسم الفرع مطلوب',
      ifscCodeInvalid: 'صيغة رمز IFSC غير صالحة',
    },
    buttons: {
      back: 'رجوع',
      submit: 'إرسال',
    },
    validationMessages: {
      requiredField: 'هذا الحقل مطلوب',
      validAccountNumber: 'رقم الحساب يجب أن يتكون من 10 إلى 20 رقم',
      validSwiftCode:
        'رمز SWIFT يجب أن يتكون من 6 حروف متبوعة من 2 أو 3 أرقام/حروف',
    },
    success: {
      formSubmitted: 'تم إرسال البيانات بنجاح',
    },
  },
  contractStep: {
    headers: {
      contractReview: 'مراجعة العقد',
      contractName: 'اتفاقية خدمات التسويق',
    },
    subHeaders: {
      reviewMessage: 'يرجى مراجعة العقد قبل التوقيع',
      languageSelection: 'يرجى اختيار لغة العقد',
    },
    labels: {
      digitalSignature: 'التوقيع الرقمي (اكتب اسمك الكامل)',
    },
    placeholders: {
      signature: 'اكتب اسمك الكامل كتوقيع',
    },
    buttons: {
      viewContract: 'عرض نموذج العقد',
      generateContract: 'إنشاء العقد',
      generatingContract: 'جاري إنشاء العقد...',
      downloadContract: 'تحميل العقد الموقع',
      next: 'التالي',
      submit: 'إرسال',
      back: 'رجوع',
    },
    success: {
      contractGenerated: 'تم إنشاء العقد بنجاح',
    },
    errors: {
      noSignature: 'يرجى تقديم توقيعك الرقمي',
      contractGeneration: 'فشل في إنشاء العقد، يرجى المحاولة مرة أخرى',
    },
  },
  infoStep: {
    title: 'المعلومات الشخصية',
    labels: {
      fullName: 'الاسم الكامل (كما في الجواز)',
      passportNumber: 'رقم الجواز',
      passportIssuanceDate: 'تاريخ إصدار الجواز',
      nationality: 'الجنسية',
      country: 'بلد الإقامة',
      mobileNumber: 'رقم الجوال',
      email: 'البريد الإلكتروني',
      agent: 'اسم الوكيل/الشركة',
    },
    placeholders: {
      fullName: 'أدخل الاسم الكامل',
      passportNumber: 'أدخل رقم الجواز',
      nationality: 'أدخل الجنسية',
      country: 'أدخل بلد الإقامة',
      mobileNumber: '+1234567890',
      email: 'example@domain.com',
      agent: 'أدخل اسم الشركة',
    },
    errors: {
      fullName: 'يجب أن يكون الاسم الكامل على الأقل 3 أحرف',
      passportNumber: 'صيغة رقم الجواز غير صالحة',
      issuanceDateRequired: 'تاريخ الإصدار مطلوب',
      invalidDate: 'صيغة التاريخ غير صالحة',
      futureDate: 'لا يمكن أن يكون تاريخ الإصدار في المستقبل',
      oldDate: 'لا يمكن أن يكون تاريخ الإصدار أقدم من 10 سنوات',
      nationalityRequired: 'الجنسية مطلوبة',
      countryRequired: 'بلد الإقامة مطلوب',
      invalidMobile: 'صيغة رقم الجوال غير صالحة',
      invalidEmail: 'صيغة البريد الإلكتروني غير صالحة',
      agentRequired: 'اسم الوكيل/الشركة مطلوب',
    },
    buttons: {
      back: 'رجوع',
      next: 'التالي',
    },
  },
  terms: {
    title: 'الإقرار والالتزام',
    acknowledgment: 'أنا الموقع أدناه، أقر وألتزم بما يلي:',
    compliance:
      'الالتزام بجميع بنود اتفاقية خدمات التسويق الموقعة مع إثراء الخير لخدمات الحج.',
    provideServices: 'تقديم خدمات التسويق على النحو التالي:',
    promotePackages:
      'الترويج لمميزات باقات وخدمات إثراء الخير عبر الوسائل الرقمية ووسائل التواصل الاجتماعي والفعاليات والمعارض.',
    encouragePilgrims:
      'تشجيع الحجاج على التسجيل في منصة نُسُك ومتابعة عمليات التسجيل عن كثب.',
    submitList:
      'تقديم قائمة بالحجاج المسجلين في منصة نُسُك قبل بدء مرحلة شراء الباقات.',
    adhereTo: 'الالتزام بما يلي:',
    uploadData: 'تحميل بيانات الحجاج في الإطار الزمني المحدد.',
    ensureAccuracy:
      'ضمان دقة البيانات وتجنب التكرار أو التطابق مع بيانات أي مرشد آخر.',
    clearMessages:
      'استخدام رسائل تسويقية واضحة تتماشى مع القيم الدينية والثقافية.',
    noComplaints: 'ضمان عدم وجود شكاوى أو مشاكل تتعلق بالخدمات المقدمة.',
    legalResponsibility:
      'تحمل المسؤولية القانونية والمالية الكاملة في حالة أي خرق للالتزامات المذكورة أعلاه.',
    agreeTerms: 'أوافق على الشروط والأحكام المذكورة أعلاه',
    next: 'التالي',
  },
  verification: {
    detailsTitle: 'تفاصيل التحقق',
    created: 'تم الإنشاء',
    lastUpdated: 'آخر تحديث',
    rejectionReason: 'سبب الرفض',
    viewContract: 'عرض العقد',
    delete: 'حذف',
    deleteSuccess: 'تم حذف التحقق بنجاح',
    deleteError: 'فشل في حذف التحقق',
    userType: 'نوع المستخدم',
    createdAt: 'تم الإنشاء في',
    personalInfo: 'المعلومات الشخصية',
    bankInfo: 'معلومات البنك',
    digitalSignature: 'التوقيع الرقمي',
    bankName: 'اسم البنك',
    accountNumber: 'رقم الحساب',
    swiftCode: 'رمز SWIFT',
    bankBranch: 'فرع البنك',
    ifscCode: 'رمز IFSC',
    noBankInfo: 'لا توجد معلومات بنكية',
    bankInfoUpdated: 'تم تحديث معلومات البنك بنجاح',
    bankInfoError: 'فشل في تحديث معلومات البنك',
    viewSignedContract: 'عرض العقد الموقع',
  },
  verificationApproval: {
    statuses: {
      approved: 'تمت الموافقة',
      rejected: 'مرفوض',
      pending: 'قيد المراجعة',
    },
    userTypes: {
      guide: 'مرشد',
      organizer: 'منظم',
    },
    createdAt: 'تاريخ الإنشاء',
    buttons: {
      viewContract: 'عرض العقد',
      delete: 'حذف',
      approve: 'موافقة',
      reject: 'رفض',
      export: 'تصدير',
      downloadContracts: 'تحميل العقود',
      cancel: 'إلغاء',
    },
    bankInfo: {
      title: 'معلومات البنك',
      bankName: 'اسم البنك',
      accountNumber: 'رقم الحساب',
      swiftCode: 'رمز SWIFT',
      bankBranch: 'فرع البنك',
      ifscCode: 'رمز IFSC',
    },
    filters: {
      searchPlaceholder: 'ابحث...',
      allStatuses: 'جميع الحالات',
      pending: 'قيد الانتظار',
      approved: 'تمت الموافقة',
      rejected: 'مرفوض',
      allTypes: 'جميع الأنواع',
      guides: 'المرشدين',
      organizers: 'المنظمين',
      activeFilters: 'الفلاتر النشطة:',
      search: 'بحث',
      status: 'الحالة',
      type: 'النوع',
    },
    dialog: {
      approveTitle: 'موافقة على التحقق',
      rejectTitle: 'رفض التحقق',
      deleteTitle: 'حذف التحقق',
      approveMessage: 'هل أنت متأكد أنك تريد الموافقة على هذا التحقق؟',
      rejectMessage: 'هل أنت متأكد أنك تريد رفض هذا التحقق؟',
      rejectionReasonLabel: 'سبب الرفض',
      deleteMessage:
        'هل أنت متأكد أنك تريد حذف هذا التحقق الخاص بـ {name}? هذه العملية لا يمكن التراجع عنها.',
    },
  },
  //
  pilgrimSelector: {
    searchPlaceholder: 'ابحث عن الاسم أو جواز السفر أو الدولة...',
    passport: 'جواز السفر',
    arrivalDate: 'تاريخ الوصول',
    noResults: 'لم يتم العثور على حجاج مطابقين',
    startSearch: 'ابدأ البحث عن حاج...',
  },
  header: {
    refresh: 'تحديث',
    refreshing: 'جاري التحديث...',
    refreshSuccess: 'تم تحديث البيانات بنجاح',
    refreshError: 'فشل في تحديث البيانات',
  },
  verificationPage: {
    verifying: 'جاري التحقق...',
    verifyNow: 'تحقق الآن',
    clickButton:
      'اضغط على الزر للتحقق من ترابط البيانات بين الحجاج والباقات والرحلات',
  },
  team: {
    title: 'فريق العمل',
    addMember: 'إضافة عضو',
  },
  evidenceViewModal: {
    title: 'إثبات المرشد',
    noEvidence: 'لم يتم تقديم إثبات بعد',
    textEvidence: 'نص الإثبات',
    imageEvidence: 'الصورة المرفقة',
    submittedAt: 'تاريخ التقديم',
    updatedAt: 'آخر تحديث',
  },
  disputeCard: {
    selectGuide: 'يجب اختيار مرشد',
    resolveSuccess: 'تم حل النزاع بنجاح',
    resolveError: 'فشل في حل النزاع',
    emailSubject: 'مهم: مطلوب التحقق من المرشد - دعم فني من أثرا الخيرات',
    emailBodyPart1: 'عزيزي',
    emailBodyPart2:
      'نحن نتواصل معك من دعم فني أثرا الخيرات بخصوص ترتيبات الحج الخاصة بك.',
    emailBodyPart3:
      'لقد تلقينا معلومات متضاربة حول مرشدك المعين. وفقًا لسجلاتنا، يدعي كلا من',
    emailBodyPart4: 'أنهم مرشدك الرسمي.',
    emailBodyPart5:
      'هل يمكنك تأكيد من هو مرشدك المعين؟ هذه المعلومة هامة لضمان تقديم الخدمة بشكل صحيح خلال رحلة الحج.',
    emailBodyPart6: 'مع أطيب التحيات،',
    emailBodyPart7: 'فريق دعم فني من أثرا الخيرات',
    emailNotAvailable: 'البريد الإلكتروني غير متوفر',
    whatsAppMessage1: 'عزيزي',
    whatsAppMessage2:
      'فريق دعم فني أثرا الخيرات يتواصل معك بخصوص ترتيبات الحج الخاصة بك.',
    whatsAppMessage3:
      'لقد تلقينا معلومات متضاربة حول مرشدك المعين. وفقًا لسجلاتنا، يدعي كلا من',
    whatsAppMessage4: 'أنهم مرشدك الرسمي.',
    whatsAppMessage5:
      'هل يمكنك تأكيد من هو مرشدك المعين؟ هذه المعلومة هامة لضمان تقديم الخدمة بشكل صحيح خلال رحلة الحج.',
    whatsAppMessage6: 'مع أطيب التحيات،',
    whatsAppMessage7: 'فريق دعم فني من أثرا الخيرات',
    phoneNotAvailable: 'رقم الهاتف غير متوفر',
    sendEmail: 'إرسال بريد إلكتروني',
    sendWhatsApp: 'إرسال عبر واتساب',
    countryNotAvailable: 'الدولة غير متوفرة',
    passport: 'جواز',
    viewEvidence: 'رؤية الإثبات',
    resolveDispute: 'حل النزاع',
    requestDate: 'تاريخ الطلب',
  },
  disputesList: {
    noDisputes: 'لا يوجد نزاعات مطابقة للفلاتر المحددة',
  },
  disputesPage: {
    header: 'النزاعات',
    description: 'إدارة النزاعات بين المرشدين على ملكية الحجاج',
  },
  linkingStats: {
    totalPilgrims: 'إجمالي الحجاج',
    countries: 'عدد الدول',
    approved: 'تم الربط',
    pending: 'قيد الانتظار',
    rejected: 'مرفوض',
  },
  linkingTableRow: {
    status: {
      approved: 'تم الربط',
      rejected: 'مرفوض',
      pending: 'قيد الانتظار',
      waitingIdentification: 'في انتظار المطابقة',
    },
    labels: {
      passport: 'جواز السفر',
    },
  },
  linkingStatusPage: {
    header: 'حالة الربط',
    description: 'متابعة حالة الربط بين المرشدين والحجاج',
  },
  verificationHeader: {
    header: 'تحقق الترابط',
    description: 'تحقق من ترابط البيانات بين الحجاج والباقات والرحلات',
  },
  flightsPage: {
    header: 'رحلات الطيران',
    downloadTemplate: 'مثال للرفع',
    addFlights: 'إضافة رحلات',
    deleteAll: 'حذف جميع الرحلات',
    uploadError: 'حدث خطأ أثناء رفع البيانات',
    deleteSuccess: 'تم حذف جميع الرحلات بنجاح',
    deleteError: 'حدث خطأ أثناء حذف الرحلات',
    deleteAllTitle: 'حذف جميع الرحلات',
    deleteAllMessage:
      'هل أنت متأكد من حذف جميع الرحلات؟ لا يمكن التراجع عن هذه العملية.',
    confirmDelete: 'حذف الجميع',
    cancel: 'إلغاء',
  },
  packagesPage: {
    header: 'باقات الحج',
    downloadTemplate: 'مثال للرفع',
    addPackages: 'إضافة باقات',
    deleteAll: 'حذف جميع الباقات',
    uploadError: 'حدث خطأ أثناء رفع البيانات',
    deleteSuccess: 'تم حذف جميع الباقات بنجاح',
    deleteError: 'حدث خطأ أثناء حذف الباقات',
    deleteAllTitle: 'حذف جميع الباقات',
    deleteAllMessage:
      'هل أنت متأكد من حذف جميع الباقات؟ لا يمكن التراجع عن هذه العملية.',
    confirmDelete: 'حذف الجميع',
    cancel: 'إلغاء',
  },
  pilgrimsPage: {
    header: 'معلومات الحجاج',
    downloadTemplate: 'مثال للرفع',
    addPilgrims: 'إضافة حجاج',
    deleteAll: 'حذف جميع الحجاج',
    uploadError: 'حدث خطأ أثناء رفع البيانات',
    deleteSuccess: 'تم حذف جميع الحجاج بنجاح',
    deleteError: 'حدث خطأ أثناء حذف الحجاج',
    deleteAllTitle: 'حذف جميع الحجاج',
    deleteAllMessage:
      'هل أنت متأكد من حذف جميع الحجاج؟ لا يمكن التراجع عن هذه العملية.',
    confirmDelete: 'حذف الجميع',
    cancel: 'إلغاء',
  },
  adminDashboard: {
    morningGreeting: 'صباح الخير',
    afternoonGreeting: 'مساء الخير',
    eveningGreeting: 'مساء الخير',
    defaultUserName: 'مدير النظام',
    welcomeMessage: 'مرحباً بك في نظام إدارة باقات الحج المتكامل',
    makkah: 'مكة المكرمة',
    madinah: 'المدينة المنورة',
    mina: 'منى',
    holyCity: 'المدينة المقدسة',
    prophetMosque: 'المسجد النبوي',
    pilgrimsCamp: 'مخيمات الحجاج',
    managePilgrims: 'إدارة الحجاج',
    movementSchedule: 'جدول التحركات',
    flights: 'الرحلات',
    accommodation: 'التسكين',
  },
  //
  organizerFinance: {
    importantNotice: 'تنبيه مهم',
    lastUpdated: 'آخر تحديث',
    disclaimerText: 'جميع المبالغ والمدفوعات المعروضة قابلة للتغيير دون أي مسائلة قانونية أو إنذار مسبق. هذا البيان ليس نهائياً ولا يمثل التزاماً مالياً من قبل إثراء الخير.',
    title: 'تمويل المنظمين',
    subtitle: 'إدارة وتتبع مدفوعات المنظمين بناءً على ملكية الحجاج',
    totalPilgrims: 'إجمالي الحجاج',
    matchingPilgrims: 'الحجاج المتطابقين',
    mismatchedPilgrims: 'الحجاج غير المتطابقين',
    totalAmount: 'المبلغ الإجمالي',
    bonusAmount: 'مبلغ المكافأة',
    savedAmount: 'المبلغ المدخر',
    pilgrimName: 'اسم الحاج',
    passportNumber: 'رقم الجواز',
    assignedGuide: 'الدليل المعين',
    owner: 'المالك',
    paymentType: 'نوع الدفع',
    amount: 'المبلغ',
    status: 'الحالة',
    matching: 'متطابق',
    mismatched: 'غير متطابق',
    fullPayment: 'دفع كامل',
    guidancePayment: 'دفع إرشاد',
    marketingPayment: 'دفع تسويق',
    summary: 'ملخص',
    baseAmount: 'المبلغ الأساسي',
    exportReport: 'تصدير التقرير',
    financialStats: {
      totalAmount: 'المبلغ الإجمالي',
      pilgrimsDistribution: 'توزيع الحجاج',
      savedAmount: 'المبلغ المدخر',
      includesBonus: 'يشمل {{bonusAmount}} رس مكافأة',
    },
    tableHeaders: {
      pilgrim: 'الحاج',
      passport: 'الجواز',
      guide: 'الدليل',
      owner: 'المالك',
      paymentType: 'نوع الدفع',
      amount: 'المبلغ (رس)',
    },
  },
  common: {
    loading: 'جاري التحميل...',
    error: 'فشل تحميل البيانات المطلوبة',
  },
  pilgrimOwnership: {
    title: 'الملكية الحقيقية للحجاج',
    subtitle: 'إدارة وتحديد الملكية الحقيقية للحجاج',
  },
  filters: {
    searchPlaceholder: 'بحث باسم الحاج أو رقم الجواز...',
    allCountries: 'كل الدول',
    allGenders: 'كل الأنواع',
    male: 'ذكر',
    female: 'أنثى',
    activeFilters: 'الفلاتر النشطة:',
    searchLabel: 'بحث:',
    countryLabel: 'الدولة:',
    genderLabel: 'النوع:',
  },
  tableHeaders: {
    pilgrim: 'الحاج',
    assignedGuide: 'المرشد المسند إليه',
    realGuide: 'مرشد نسك',
    ownership: 'ملكية الحاج',
    compatibility: 'التوافق',
    passport: 'جواز:',
    noGuide: 'لا يوجد',
    selectRealGuide: 'اختر مرشد نسك...',
    selectOwner: 'اختر المالك...',
  },
  toasts: {
    realGuideUpdated: 'تم تحديث مرشد نسك بنجاح',
    realGuideUpdateFailed: 'فشل في تحديث مرشد نسك',
    ownershipUpdated: 'تم تحديث ملكية الحاج بنجاح',
    ownershipUpdateFailed: 'فشل في تحديث ملكية الحاج',
  },
  compatibility: {
    match: 'مطابق',
    mismatch: 'غير مطابق',
  },
  pilgrimGuideStore: {
    errors: {
      pilgrimNotFound: 'لم يتم العثور على حاج بهذا الرقم',
      linkFailed: 'فشل في ربط الحاج بالمرشد',
      deleteFailed: 'فشل في حذف الرابط',
    },
    success: {
      linkSuccess: 'تم ربط الحاج بالمرشد بنجاح',
      deleteSuccess: 'تم حذف الرابط بنجاح',
    },
  },
  pilgrimsStore: {
    success: {
      uploadPilgrims: 'تم إضافة {count} حاج بنجاح',
    },
    errors: {
      uploadPilgrims: 'فشل في إضافة الحجاج',
      deletePilgrim: 'فشل في حذف الحاج',
      deleteAll: 'فشل في حذف جميع الحجاج',
      searchPilgrims: 'فشل في البحث عن الحجاج',
    },
  },
  addSuspensionModal: {
    title: 'إضافة تعليق جديد',
    labels: {
      suspensionType: 'نوع التعليق',
      hotel: 'الفندق',
      selectHotel: 'اختر الفندق',
      reason: 'سبب التعليق',
      duration: 'مدة التعليق',
      temporary: 'مؤقت',
      permanent: 'دائم',
      expiryDate: 'تاريخ الانتهاء',
    },
    suspensionTypes: {
      linking: 'تعليق خدمة الربط',
      allAccommodation: 'تعليق خدمة التسكين (الكل)',
      specificHotel: 'تعليق فندق محدد',
      campAccommodation: 'تعليق تسكين المخيمات',
    },
    buttons: {
      cancel: 'إلغاء',
      addSuspension: 'إضافة التعليق',
      adding: 'جاري الإضافة...',
    },
    errors: {
      allFieldsRequired: 'جميع الحقول مطلوبة',
      expiryDateRequired: 'يرجى تحديد تاريخ انتهاء التعليق',
      suspensionAddFailed: 'فشل في إضافة التعليق',
    },
    success: {
      suspensionAdded: 'تم إضافة التعليق بنجاح',
    },
  },
  addBanModal: {
    title: 'إضافة حظر جديد',
    labels: {
      userType: 'نوع المستخدم',
      guide: 'مرشد',
      organizer: 'منظم',
      selectUser: 'اختر',
      banType: 'نوع الحظر',
      reason: 'سبب الحظر',
      duration: 'مدة الحظر',
      temporary: 'مؤقت',
      permanent: 'دائم',
      expiryDate: 'تاريخ الانتهاء',
    },
    banTypes: {
      full: 'حظر كامل',
      accommodation: 'حظر التسكين',
      linking: 'حظر الربط',
      camp: 'حظر المخيمات',
    },
    buttons: {
      cancel: 'إلغاء',
      addBan: 'إضافة الحظر',
      adding: 'جاري الإضافة...',
    },
    errors: {
      allFieldsRequired: 'جميع الحقول مطلوبة',
      expiryDateRequired: 'يرجى تحديد تاريخ انتهاء الحظر',
      banAddFailed: 'فشل في إضافة الحظر',
    },
    success: {
      banAdded: 'تم إضافة الحظر بنجاح',
    },
  },
  accommodation: {
    errors: {
      serviceSuspended: 'خدمة التسكين معلقة حالياً',
      hotelSuspended: 'هذا الفندق معلق حالياً',
      notAuthenticated: 'غير مصرح لك بالقيام بهذه العملية',
      notAuthorized: 'غير مصرح لك بالقيام بهذه العملية',
      userBanned: 'أنت محظور من استخدام خدمة التسكين',
      packageNotFound: 'لم يتم العثور على الباقة الخاصة بالحاج',
      hotelNotAssigned: 'هذا الفندق غير مخصص لباقة هذا الحاج',
      pilgrimNotFound: 'لم يتم العثور على حاج بهذا الرقم',
      noGuideLinked: 'الحاج غير مرتبط بأي مرشد',
      noPermission: 'ليس لديك صلاحية للقيام بهذه العملية',
      tableNotFound: 'جدول التسكين غير موجود',
      roomNotFound: 'الغرفة غير موجودة',
      roomNumberExists: 'رقم الغرفة موجود بالفعل',
      commentTextRequired: 'يجب إدخال نص التعليق',
      userInfoRequired: 'معلومات المستخدم غير متوفرة',
      noComments: 'لا توجد تعليقات',
      invalidRoomNumber: 'رقم الغرفة غير صالح',
      invalidRoomType: 'نوع الغرفة غير صالح',
      excelParseError: 'فشل في قراءة ملف Excel. تأكد من صحة البيانات',
    },
    header: 'تسكين الفنادق',
    description: 'إدارة تسكين الحجاج في الفنادق',
    addButton: 'إضافة جدول تسكين',
    noTables: 'لا يوجد جداول تسكين حالياً',
  },
  bansManagement: {
    header: {
      title: 'إدارة الحظر والتعليق',
      subtitle: 'إدارة حظر المستخدمين وتعليق الخدمات',
    },
    buttons: {
      addBan: 'إضافة حظر جديد',
      addSuspension: 'تعليق خدمة',
    },
    stats: {
      activeBans: 'الحظر النشط',
      expiredBans: 'الحظر المنتهي',
      activeSuspensions: 'التعليقات النشطة',
      totalActions: 'إجمالي الإجراءات',
    },
    disputeBans: {
      title: 'حظر النزاعات',
      bannedFrom: 'محظور من التعامل مع الحاج',
      noBans: 'لا يوجد حظر نزاعات حالياً',
    },
    activeBans: {
      title: 'الحظر النشط',
      guide: 'مرشد',
      organizer: 'منظم',
      expiresOn: 'ينتهي في',
      permanentBan: 'حظر دائم',
      noBans: 'لا يوجد حظر نشط حالياً',
    },
    activeSuspensions: {
      title: 'التعليقات النشطة',
      linking: 'تعليق خدمة الربط',
      allAccommodation: 'تعليق خدمة التسكين (الكل)',
      specificHotel: 'فندق',
      campAccommodation: 'تعليق تسكين المخيمات',
      by: 'بواسطة',
      expiresOn: 'ينتهي في',
      permanentSuspension: 'تعليق دائم',
      noSuspensions: 'لا يوجد تعليقات نشطة حالياً',
    },
    confirmDialog: {
      deactivateBanTitle: 'إلغاء الحظر',
      deactivateBanMessage: 'هل أنت متأكد من إلغاء هذا الحظر؟',
      deactivateSuspensionTitle: 'إلغاء التعليق',
      deactivateSuspensionMessage: 'هل أنت متأكد من إلغاء هذا التعليق؟',
      deleteBanTitle: 'حذف الحظر',
      deleteBanMessage: 'هل أنت متأكد من حذف هذا الحظر نهائياً؟',
      deleteSuspensionTitle: 'حذف التعليق',
      deleteSuspensionMessage: 'هل أنت متأكد من حذف هذا التعليق نهائياً؟',
      removeDisputeBanTitle: 'إلغاء حظر النزاع',
      removeDisputeBanMessage: 'هل أنت متأكد من إلغاء حظر المرشد',
      from: 'من',
      confirmText: 'تأكيد',
      cancelText: 'إلغاء',
    },
    success: {
      removeDisputeBan: 'تم إلغاء الحظر بنجاح',
      deactivateBan: 'تم إلغاء الحظر بنجاح',
      deactivateSuspension: 'تم إلغاء التعليق بنجاح',
      deleteBan: 'تم حذف الحظر بنجاح',
      deleteSuspension: 'تم حذف التعليق بنجاح',
    },
    errors: {
      fetchDisputeBans: 'فشل في جلب بيانات الحظر من النزاعات',
      removeDisputeBan: 'فشل في إلغاء الحظر',
      deactivateBan: 'فشل في إلغاء الحظر',
      deactivateSuspension: 'فشل في إلغاء التعليق',
      deleteBan: 'فشل في حذف الحظر',
      deleteSuspension: 'فشل في حذف التعليق',
    },
  },
  //
  accommodationLogs: {
    header: 'سجل النشاطات',
    subheader: 'متابعة نشاطات التسكين في الفنادق',
    searchPlaceholder: 'بحث...',
    filters: {
      allHotels: 'كل الفنادق',
      allActions: 'كل العمليات',
      allRoles: 'كل الأدوار',
      assign: 'تسكين',
      remove: 'إلغاء تسكين',
      admin: 'مدير النظام',
      guide: 'مرشد',
      organizer: 'منظم',
      search: 'بحث',
      hotel: 'الفندق',
      action: 'العملية',
      role: 'الدور',
    },
    activeFilters: 'الفلاتر النشطة:',
    logActions: {
      assign: 'تم التسكين',
      remove: 'تم إلغاء التسكين',
    },
    logDetails: {
      pilgrimInfo: 'معلومات الحاج',
      accommodationInfo: 'معلومات التسكين',
      room: 'غرفة',
      bed: 'سرير',
      performedBy: 'تم بواسطة:',
    },
    noLogs: 'لا توجد سجلات نشاط مطابقة للفلاتر المحددة',
  },
  PilgrimGuide: {
    messages: {
      deleteSuccess: 'تم حذف الرابط بنجاح',
      deleteError: 'فشل في حذف الرابط',
    },
    errors: {
      deletePermission: 'ليس لديك إذن لحذف هذا الرابط',
      invalidLinkId: 'معرّف الرابط غير صالح',
      noDispute: 'لا يوجد نزاع متاح لتقديم الإثبات',
    },
    confirmDialog: {
      deleteTitle: 'حذف الرابط',
      disputeMessage:
        'حذف هذا الرابط سينهي النزاع ويعطي الحق للدليل الآخر. هل أنت متأكد أنك تريد حذف الرابط للحاج {name}؟',
      defaultMessage: 'هل أنت متأكد أنك تريد حذف الرابط للحاج {name}؟',
      deleting: 'جاري الحذف...',
      delete: 'حذف',
      cancel: 'إلغاء',
    },
  },
  evidenceModal: {
    title: 'تقديم إثبات',
    textLabel: 'نص الإثبات',
    textPlaceholder: 'اكتب تفاصيل الإثبات هنا...',
    textRequiredError: 'يجب إدخال نص الإثبات',
    imageLabel: 'صورة الإثبات (اختياري)',
    uploadButton: 'رفع ملف',
    dragAndDrop: 'أو سحب وإفلات',
    fileRequirements: 'PNG, JPG حتى 5MB',
    fileSizeError: 'حجم الملف يجب أن يكون أقل من 5MB',
    uploadError: 'فشل في رفع الصورة',
    uploadWaitError: 'الرجاء الانتظار حتى اكتمال رفع الصورة',
    uploadingText: 'جاري رفع الصورة...',
    cancelButton: 'إلغاء',
    submitButton: 'تقديم الإثبات',
    savingButton: 'جاري الحفظ...',
    submitSuccess: 'تم تقديم الإثبات بنجاح',
    submitError: 'فشل في تقديم الإثبات',
  },
  linkPilgrimToGuideAction: {
    banError: 'لا يمكنك ربط هذا الحاج بسبب وجود حظر من نزاع سابق',
    alreadyLinkedError: 'هذا الحاج مرتبط بك بالفعل',
    linkError: 'فشل في ربط الحاج بالمرشد',
    waitingIdentificationExists: 'هذا الحاج بانتظار المطابقة بالفعل',
    waitingIdentificationName: 'في انتظار المطابقة',
  },
  deleteLinkAction: {
    linkNotFound: 'الرابط غير موجود',
    deleteError: 'فشل في حذف الرابط',
    hotelAccommodationError:
      'لا يمكن حذف الحاج لأنه مسكن في فندق {hotelName} غرفة {roomNumber}',
    campAccommodationError:
      'لا يمكن حذف الحاج لأنه مسكن في مخيم {campName} خيمة {tentNumber} صالة {hallNumber}',
  },
  activeFilters: {
    activeFiltersLabel: 'الفلاتر النشطة:',
    searchLabel: 'بحث:',
    statusLabel: 'الحالة:',
    countryLabel: 'الدولة:',
    statusApproved: 'تم الربط',
    statusPending: 'قيد الانتظار',
    statusDisputed: 'متنازع عليه',
    statusRejected: 'مرفوض',
    statusWaitingIdentification: 'في انتظار المطابقة',
  },
  resetPasswordModal: {
    title: 'تغيير كلمة المرور',
    newPasswordLabel: 'كلمة المرور الجديدة',
    confirmPasswordLabel: 'تأكيد كلمة المرور',
    cancelButton: 'إلغاء',
    saveButton: 'حفظ',
    savingButton: 'جاري الحفظ...',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    passwordLengthError: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    passwordChangeSuccess: 'تم تغيير كلمة المرور بنجاح',
    passwordChangeError: 'فشل في تغيير كلمة المرور',
  },
  campAccommodationTable: {
    exportSuccess: 'تم تصدير بيانات التسكين بنجاح',
    exportError: 'فشل في تصدير بيانات التسكين',
    deleteSuccess: 'تم حذف جدول التسكين بنجاح',
    deleteError: 'فشل في حذف جدول التسكين',
    deleteTitle: 'حذف جدول التسكين',
    deleteMessage: 'هل أنت متأكد من حذف جدول',
    deleteButton: 'حذف الجدول',
    confirmDelete: 'حذف',
    cancelDelete: 'إلغاء',
    tents: 'الخيم',
    capacity: 'السعة',
    occupancyRate: 'نسبة الإشغال',
    occupiedTotal: 'المشغول / الكلي',
    percentage: 'النسبة المئوية',
    viewDetails: 'عرض التفاصيل',
    exportTitle: 'تحميل التسكين',
    exportButton: 'تحميل التسكين',
  },
  settingsPage: {
    headerTitle: 'الإعدادات',
    headerSubtitle: 'إدارة إعدادات الحساب',
    changePasswordTitle: 'تغيير كلمة المرور',
    currentPasswordLabel: 'كلمة المرور الحالية',
    newPasswordLabel: 'كلمة المرور الجديدة',
    newPasswordPlaceholder: 'أدخل كلمة المرور الجديدة',
    updateButton: 'تحديث كلمة المرور',
    updating: 'جاري التحديث...',
    newPasswordRequired: 'يرجى إدخال كلمة المرور الجديدة',
    passwordLengthError: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    updateSuccess: 'تم تحديث كلمة المرور بنجاح',
    updateError: 'فشل في تحديث كلمة المرور',
    recentLoginRequired:
      'يرجى تسجيل الخروج وإعادة تسجيل الدخول لتحديث كلمة المرور',
    fetchError: 'فشل في جلب بيانات المستخدم',
  },
  pilgrimSelector: {
    searchPlaceholder: 'بحث باسم الحاج أو رقم الجواز...',
    passport: 'جواز',
    package: 'الباقة',
    noResults: 'لا يوجد حجاج مطابقين للبحث',
    startSearch: 'ابدأ البحث عن حاج...',
  },
  campBedModal: {
    tent: 'خيمة',
    hall: 'صالة',
    bed: 'سرير',
    noPermissionAssign: 'ليس لديك صلاحية لتسكين الحجاج',
    noPermissionRemove: 'ليس لديك صلاحية لإزالة الحاج',
    noPermissionManage: 'ليس لديك صلاحية لإدارة هذا السرير',
    assignSuccess: 'تم تسكين الحاج بنجاح',
    assignError: 'فشل في تسكين الحاج',
    removeSuccess: 'تم إلغاء تسكين الحاج بنجاح',
    removeError: 'فشل في إلغاء تسكين الحاج',
    removeButton: 'إلغاء التسكين',
    assignInstructions:
      'يرجى اختيار حاج للتسكين في هذا السرير. تأكد من أن الحاج:',
    assignRule1: 'لم يتم تسكينه في مكان آخر',
    assignRule2: 'يتناسب مع نوع الصالة ({gender})',
    assignRule3: 'مرتبط بمرشد معتمد',
    male: 'رجال',
    female: 'نساء',
  },
  campDetails: {
    notFound: 'جدول التسكين غير موجود',
    stats: {
      totalTents: 'إجمالي الخيم',
      totalHalls: 'إجمالي الصالات',
      occupiedBeds: 'الأسرّة المشغولة',
      occupancyRate: 'نسبة الإشغال',
    },
    filters: {
      searchPlaceholder: 'بحث برقم الخيمة أو اسم الحاج...',
      allGenders: 'كل الأنواع',
      male: 'رجال',
      female: 'نساء',
      allOccupancy: 'كل الحالات',
      occupied: 'مشغول',
      available: 'متاح',
    },
    tentHeader: 'خيمة',
    hallHeader: 'صالة',
    available: 'متاح',
  },
  campAccommodation: {
    header: {
      title: 'تسكين المخيمات',
      subtitle: 'إدارة تسكين الحجاج في مخيمات منى وعرفات',
    },
    addTableButton: 'إضافة جدول تسكين',
    stats: {
      totalCamps: 'إجمالي المخيمات',
      occupiedTents: 'الخيم المشغولة',
      totalCapacity: 'إجمالي السعة',
      occupancyRate: 'نسبة الإشغال',
    },
    noTablesMessage: 'لا يوجد جداول تسكين حالياً',
    errors: {
      serviceSuspended: 'خدمة تسكين المخيمات معلقة حالياً',
      notAuthenticated: 'غير مصرح لك بالقيام بهذه العملية',
      userBanned: 'أنت محظور من استخدام خدمة تسكين المخيمات',
      pilgrimNotFound: 'لم يتم العثور على حاج بهذا الرقم',
      noGuideLinked: 'الحاج غير مرتبط بأي مرشد',
      noPermission: 'ليس لديك صلاحية للقيام بهذه العملية',
      tableNotFound: 'جدول التسكين غير موجود',
      tentNotFound: 'الخيمة غير موجودة',
      hallNotFound: 'الصالة غير موجودة',
      genderMismatch: 'لا يمكن تسكين الحاج في هذه الصالة بسبب اختلاف الجنس',
      notAuthorized: 'غير مصرح لك بالقيام بهذه العملية',
    },
  },
  room: {
    roomTypes: {
      double: 'ثنائية',
      triple: 'ثلاثية',
      quadruple: 'رباعية',
    },
  },
  pilgrimsTable: {
    searchPlaceholder: 'بحث بالاسم أو معرف منصة نسك...',
    exportButton: 'تصدير Excel',
    activeFilters: 'الفلاتر النشطة',
    filters: {
      allGenders: 'كل الأنواع',
      male: 'ذكر',
      female: 'أنثى',
      allRoomTypes: 'كل أنواع الغرف',
      double: 'ثنائية',
      triple: 'ثلاثية',
      quadruple: 'رباعية',
      search: 'بحث',
      gender: 'النوع',
      roomType: 'نوع الغرفة',
    },
    tableHeaders: {
      pilgrim: 'الحاج',
      packageInfo: 'معلومات الباقة',
      flightInfo: 'معلومات السفر',
      accommodation: 'الإقامة',
      contact: 'التواصل',
      passport: 'جواز',
      serialNumber: 'معرف منصة نسك',
      pnr: 'PNR',
      ticket: 'تذكرة',
      mainMakkahRoom: 'مكة الرئيسية',
      shiftingMakkahRoom: 'مكة الأنتقالية',
      madinahRoom: 'المدينة',
      residence: 'إقامة',
      nationality: 'جنسية',
    },
    pagination: {
      page: 'صفحة',
      of: 'من',
      pilgrims: 'حاج',
    },
  },
  roomDetailsModal: {
    room: 'الغرفة',
    roomInfo: 'معلومات الغرفة',
    occupancy: 'الإشغال',
    pilgrims: 'الحجاج',
    bed: 'سرير',
    guide: 'المرشد',
    noPilgrims: 'لا يوجد حجاج في هذه الغرفة',
    roomTypes: {
      double: 'ثنائية',
      triple: 'ثلاثية',
      quadruple: 'رباعية',
    },
  },
  //
  landing: {
    hero: {
      title: 'نظام إدارة الحج والعمرة',
      subtitle: 'المتكامل',
      description:
        'قم بتنظيم عملياتك بكفاءة من خلال منصتنا المتكاملة لإدارة السكن والنقل وخدمات الحجاج',
      cta: 'الدخول للنظام',
    },
    features: {
      title: 'المميزات الرئيسية',
      accommodation: {
        title: 'إدارة السكن',
        description:
          'إدارة سكن الحجاج بكفاءة عالية من خلال نظام الإسكان المتطور',
      },
      movement: {
        title: 'تنسيق التنقلات',
        description: 'تتبع وتنسيق تحركات الحجاج في الوقت الفعلي',
      },
      camp: {
        title: 'إدارة المخيمات',
        description: 'أدوات شاملة لإدارة مخيمات الحجاج والمرافق',
      },
      services: {
        title: 'خدمات الحجاج',
        description: 'تقديم الخدمات بسلاسة لتلبية جميع احتياجات الحجاج',
      },
    },
    benefits: {
      title: 'مميزات النظام',
      satisfaction: 'رضا العملاء',
      pilgrims: 'حاج معتمر',
      support: 'دعم متواصل',
      features: 'خاصية متكاملة',
    },
    systemFeatures: {
      title: 'ميزات النظام المتكاملة',
      hotel: {
        title: 'إدارة الفنادق',
        description: 'إدارة مرئية تفاعلية للغرف والإشغال الفندقي',
      },
      flight: {
        title: 'إدارة الرحلات',
        description: 'تنسيق حجوزات الطيران وإدارة الجداول',
      },
      task: {
        title: 'تتبع المهام',
        description: 'إدارة شاملة للمهام ومراقبة التقدم',
      },
      guide: {
        title: 'تعيين المرشدين',
        description: 'نظام فعال لتخصيص وإدارة المرشدين',
      },
    },
    finalCta: {
      title: 'هل أنت مستعد للبدء؟',
      description:
        'قم بالوصول إلى لوحة التحكم لإدارة السكن والحركات وخدمات الحجاج',
      cta: 'الدخول للنظام',
    },
    stats: {
      totalCamps: 'إجمالي المخيمات',
      occupiedTents: 'الخيم المشغولة',
      totalCapacity: 'إجمالي السعة',
      occupancyRate: 'نسبة الإشغال',
      pilgrims: 'حجاج',
      camps: 'مخيمات',
      capacity: 'سعة',
      rate: 'نسبة',
    },
    systemBenefits: {
      title: 'مزايا النظام',
      efficiency: {
        title: 'كفاءة عالية',
        description: 'إدارة سلسة وفعالة لجميع العمليات',
      },
      realTime: {
        title: 'تحديثات فورية',
        description: 'تتبع البيانات والتحركات في الوقت الفعلي',
      },
      integration: {
        title: 'تكامل شامل',
        description: 'نظام متكامل يربط جميع الخدمات ببعضها',
      },
      support: {
        title: 'دعم فني متواصل',
        description: 'فريق دعم متاح على مدار الساعة',
      },
    },
    mainFeatures: {
      title: 'الميزات الرئيسية',
      accommodation: {
        title: 'إدارة السكن',
        description: 'إدارة أماكن إقامة الحجاج بكفاءة',
      },
      transportation: {
        title: 'إدارة النقل',
        description: 'تنظيم حركة الحجاج بين المواقع المقدسة',
      },
      tasks: {
        title: 'إدارة المهام',
        description: 'تتبع وإدارة مهام الحجاج والفرق',
      },
      guides: {
        title: 'إدارة المرشدين',
        description: 'تعيين وتتبع المرشدين للحجاج',
      },
    },
  },
  auth: {
    loginTitle: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    login: 'تسجيل الدخول',
    loggingIn: 'جاري تسجيل الدخول...',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    loginError: 'فشل تسجيل الدخول. يرجى التحقق من البريد الإلكتروني وكلمة المرور.',
    resetPassword: 'إعادة تعيين كلمة المرور',
    resetInstructions: 'أدخل عنوان بريدك الإلكتروني وسنرسل إليك تعليمات لإعادة تعيين كلمة المرور الخاصة بك.',
    emailRequired: 'البريد الإلكتروني مطلوب',
    resetSuccess: 'تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور. يرجى التحقق من صندوق الوارد.',
    resetError: 'فشل إرسال بريد إعادة التعيين. يرجى المحاولة مرة أخرى.',
    cancel: 'إلغاء',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    sending: 'جاري الإرسال...',
    collaborationMessage: 'بدعم من شراكتنا للتميز',
    collaborationSubtext: 'نقدم الجديد في خدمات الحج',
    ithraaLogoAlt: 'إثراء الخير',
    rehabLogoAlt: 'شركة رحاب',
    copyright: '© 2025 جميع الحقوق محفوظة لشركة رحاب',
    poweredBy: 'تم التطوير بواسطة شركة رحاب'
  },
  authh: {
    logout: 'تسجيل الخروج',
  },
  components: {
    header: {
      userInfo: {
        organizerName: 'اسم المنظم',
        gender: {
          male: 'ذكر',
          female: 'أنثى',
        },
      },
      logout: 'تسجيل الخروج',
    },
  },
  dashboard: {
    title: 'لوحة التحكم',
    stats: {
      totalMembers: 'إجمالي الأعضاء',
      activeMembers: 'الأعضاء النشطين',
      suspendedMembers: 'الأعضاء الموقوفين',
    },
    recentActivity: {
      title: 'النشاطات الأخيرة',
      types: {
        login: 'تسجيل دخول',
        update: 'تحديث البيانات',
        create: 'إضافة عضو جديد',
      },
    },
  },
  team: {
    title: 'فريق العمل',
    addMember: 'إضافة عضو جديد',
    search: {
      placeholder: 'بحث باسم المستخدم أو البريد الإلكتروني...',
      filters: {
        title: 'الفلاتر النشطة',
        allRoles: 'كل الأدوار',
        allGenders: 'كل الأنواع',
        allStatuses: 'كل الحالات',
        male: 'ذكر',
        female: 'أنثى',
        active: 'نشط',
        suspended: 'موقوف',
        clearFilters: 'مسح الفلاتر',
      },
    },
    noResults: 'لا يوجد مستخدمين مطابقين للفلاتر المحددة',
    form: {
      title: {
        add: 'إضافة عضو جديد',
        edit: 'تعديل بيانات العضو',
        selectRole: 'اختر الدور',
      },
      fields: {
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        gender: 'النوع',
        role: 'الدور الوظيفي',
        status: 'الحالة',
      },
      buttons: {
        save: 'حفظ',
        saving: 'جاري الحفظ...',
        cancel: 'إلغاء',
      },
      validation: {
        required: 'هذا الحقل مطلوب',
        emailInvalid: 'البريد الإلكتروني غير صالح',
        passwordLength: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
      },
    },
    delete: {
      title: 'حذف العضو',
      message:
        'هل أنت متأكد من حذف العضو "{name}"؟ لا يمكن التراجع عن هذه العملية.',
      confirm: 'حذف',
      cancel: 'إلغاء',
    },
    messages: {
      addSuccess: 'تم إضافة العضو بنجاح',
      addError: 'فشل في إضافة العضو',
      updateSuccess: 'تم تحديث بيانات العضو بنجاح',
      updateError: 'فشل في تحديث بيانات العضو',
      deleteSuccess: 'تم حذف العضو بنجاح',
      deleteError: 'فشل في حذف العضو',
    },
  },
  //
  roles: {
    title: 'الأدوار والصلاحيات',
    addRole: 'إضافة دور جديد',
    labels: {
      admin: 'مسؤول النظام',
      guide: 'مرشد',
      organizer: 'منظم',
    },
    form: {
      title: {
        add: 'إضافة دور جديد',
        edit: 'تعديل الدور',
      },
      fields: {
        name: 'اسم الدور',
        permissions: 'الصلاحيات',
      },
      sections: {
        dashboard: 'لوحة التحكم',
        team: 'فريق العمل',
        roles: 'الأدوار والصلاحيات',
      },
      validation: {
        required: 'هذا الحقل مطلوب',
        selectPermissions: 'يجب اختيار صلاحية واحدة على الأقل',
      },
      buttons: {
        save: 'حفظ',
        saving: 'جاري الحفظ...',
        cancel: 'إلغاء',
      },
    },
    permissions: {
      title: 'الصلاحيات',
      create: 'إنشاء',
      read: 'قراءة',
      update: 'تعديل',
      delete: 'حذف',
    },
    actions: {
      edit: 'تعديل',
      delete: 'حذف',
    },
    delete: {
      title: 'حذف الدور',
      message:
        'هل أنت متأكد من حذف دور "{name}"؟ لا يمكن التراجع عن هذه العملية.',
      confirm: 'حذف',
      cancel: 'إلغاء',
    },
    messages: {
      addSuccess: 'تم إضافة الدور بنجاح',
      addError: 'فشل في إضافة الدور',
      updateSuccess: 'تم تحديث الدور بنجاح',
      updateError: 'فشل في تحديث الدور',
      deleteSuccess: 'تم حذف الدور بنجاح',
      deleteError: 'فشل في حذف الدور',
    },
  },
  organizers: {
    title: 'المنظمين',
    addOrganizer: 'إضافة منظم جديد',
    form: {
      title: {
        add: 'إضافة منظم جديد',
        edit: 'تعديل بيانات المنظم',
      },
      fields: {
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        confirmPassword: 'تأكيد كلمة المرور',
      },
      validation: {
        required: 'هذا الحقل مطلوب',
        emailInvalid: 'البريد الإلكتروني غير صالح',
        passwordLength: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
        passwordsNotMatch: 'كلمات المرور غير متطابقة',
      },
      buttons: {
        save: 'حفظ',
        saving: 'جاري الحفظ...',
        cancel: 'إلغاء',
      },
    },
    table: {
      name: 'المنظم',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      actions: 'الإجراءات',
    },
    actions: {
      edit: 'تعديل',
      delete: 'حذف',
      resetPassword: 'تغيير كلمة المرور',
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      copyEmail: 'نسخ البريد الإلكتروني',
      copyPassword: 'نسخ كلمة المرور',
    },
    messages: {
      addSuccess: 'تم إضافة المنظم بنجاح',
      addError: 'فشل في إضافة المنظم',
      updateSuccess: 'تم تحديث بيانات المنظم بنجاح',
      updateError: 'فشل في تحديث بيانات المنظم',
      deleteSuccess: 'تم حذف المنظم بنجاح',
      deleteError: 'فشل في حذف المنظم',
      resetSuccess: 'تم تغيير كلمة المرور بنجاح',
      resetError: 'فشل في تغيير كلمة المرور',
      copySuccess: 'تم النسخ بنجاح',
      copyError: 'فشل في النسخ',
    },
    delete: {
      title: 'حذف المنظم',
      message:
        'هل أنت متأكد من حذف المنظم "{name}"؟ لا يمكن التراجع عن هذه العملية.',
      confirm: 'حذف',
      cancel: 'إلغاء',
    },
    resetPassword: {
      title: 'تغيير كلمة المرور',
      newPassword: 'كلمة المرور الجديدة',
      confirmPassword: 'تأكيد كلمة المرور',
    },
  },
  management: {
    title: 'الإدارة',
  },
  menu: {
    dashboard: 'لوحة التحكم',
    pilgrims: 'الحجاج',
    packages: 'الباقات',
    flights: 'الرحلات',
    verification: 'التحقق',
    pilgrimGuide: 'ربط الحجاج',
    linkingStatus: 'حالة الربط',
    disputes: 'المنازعات',
    accommodationTasks: 'مهام التسكين',
    accommodation: 'التسكين',
    hotelVisualization: 'رؤية الفنادق',
    team: 'فريق العمل',
    roles: 'الأدوار والصلاحيات',
    organizers: 'المنظمين',
    guides: 'المرشدين',
    movements: 'جدول التحركات',
    campAccommodation: 'تسكين المخيمات',
    accommodationLogs: 'سجل التسكين',
    settings: 'الإعدادات',
    bans: 'اعدادات الحظر',
    pilgrimOwnership: 'ملكية الحجاج',
    organizerFinance: 'اموال المنظم',
    verificationWizard: 'عقد المرشد/المنظم',
    verificationApproval: 'عقود المنظمين / المرشدين',
  },
  menuGroups: {
    dashboard: 'لوحة التحكم',
    management: 'إدارة البيانات',
    linking: 'الربط',
    accommodation: 'التسكين',
    settings: 'الإعدادات',
  },
  pilgrimGuide: {
    header: 'ربط الحجاج بالمرشدين',
    guideDescription: 'أضف الحجاج إلى قائمة الإشراف الخاصة بك.',
    adminDescription: 'ربط الحجاج بالمرشدين المناسبين وإدارة العلاقة بينهم.',
    addButton: 'إضافة حاج',
    linkButton: 'ربط حاج بمرشد',
  },
  pilgrimGuideDetails: {
    header: {
      basicInfo: 'معلومات الحاج',
      contactInfo: 'معلومات التواصل',
      locationInfo: 'معلومات الإقامة',
      hotelInfo: 'معلومات الفنادق',
      mainMakkahHotel: 'فندق مكة الأساسي',
      shiftingMakkahHotel: 'فندق مكة الانتقالي',
      madinahHotel: 'فندق المدينة',
    },
    labels: {
      name: 'الاسم',
      passport: 'رقم الجواز',
      gender: {
        male: 'ذكر',
        female: 'أنثى',
      },
      age: 'العمر',
      mobile: 'رقم الجوال',
      email: 'البريد الإلكتروني',
      residenceCountry: 'بلد الإقامة',
      nationality: 'الجنسية',
      hotelName: 'اسم الفندق',
      roomType: 'نوع الغرفة',
      roomNumber: 'رقم الغرفة',
      years: 'سنة',
    },
  },
  statusBadge: {
    statuses: {
      approved: 'تم الربط',
      disputed: 'متنازع عليه',
      rejected: 'مرفوض',
      pending: 'قيد الانتظار',
      waitingIdentification: 'في انتظار المطابقة',
    },
    actions: {
      viewEvidence: 'رؤية الإثبات',
      editEvidence: 'تعديل',
      submitEvidence: 'تقديم الإثبات',
    },
  },
  linkingTable: {
    filters: {
      searchPlaceholder: 'بحث باسم الحاج أو رقم الجواز...',
      allStatuses: 'كل الحالات',
      approved: 'تم الربط',
      pending: 'قيد الانتظار',
      rejected: 'مرفوض',
      waitingIdentification: 'في انتظار المطابقة',
      allCountries: 'كل الدول',
      activeFilters: 'الفلاتر النشطة',
      search: 'بحث',
      status: 'الحالة',
      country: 'الدولة',
    },
    tableHeaders: {
      pilgrim: 'الحاج',
      guide: 'المرشد',
      organizer: 'المنظم',
      status: 'الحالة',
    },
    pagination: {
      page: 'صفحة',
      of: 'من',
      pilgrimsCount: 'حاج',
    },
  },
  //
  packageInfo: {
    pilgrimType: 'نوع الحاج',
    nusukGroup: 'مجموعة نسك',
  },
  pilgrimGuideTable: {
    headers: {
      pilgrimInfo: 'معلومات الحاج', // Translation for "Pilgrim Info"
      package: 'الباقة', // Translation for "Package"
      guideAndOrganizer: 'المرشد والمنظم', // Translation for "Guide & Organizer"
      status: 'الحالة', // Translation for "Status"
    },
    pagination: {
      page: 'صفحة', // Translation for "Page"
      of: 'من', // Translation for "of"
      pilgrimCount: 'حاج', // Translation for "pilgrims"
    },
  },
  pilgrimInfo: {
    passport: 'جواز',
  },
  filters: {
    searchPlaceholder: 'بحث باسم الحاج أو رقم الجواز أو رقم PNR...',
    allGenders: 'كل الأنواع',
    allCountries: 'كل الدول', // Translation for "All Countries"
    male: 'ذكر',
    female: 'أنثى',
    allNationalities: 'كل الجنسيات',
    unitedKingdom: 'المملكة المتحدة',
    malaysia: 'ماليزيا',
    indonesia: 'إندونيسيا',
    allPackages: 'كل أنواع الباقات',
    mainPackage: 'أساسي',
    shiftingPackage: 'متنقل',
    allHotels: 'كل الفنادق',
    vocoHotel: 'فندق فوكو',
    hiltonHotel: 'فندق هيلتون',
    marriottHotel: 'فندق ماريوت',
    allStatuses: 'كل الحالات',
    approved: 'تمت الموافقة',
    pending: 'قيد الانتظار',
    rejected: 'مرفوض',
    activeFilters: 'الفلاتر النشطة',
    search: 'بحث',
    gender: 'النوع',
    nationality: 'الجنسية',
    packageType: 'نوع الباقة',
    hotel: 'الفندق',
    status: 'الحالة',
    clearFilters: 'مسح الفلاتر',
  },
  statusFilter: {
    allStatuses: 'كل الحالات', // All Statuses
    approved: 'تم الربط', // Approved
    pending: 'قيد الانتظار', // Pending
    rejected: 'مرفوض', // Rejected
    disputed: 'متنازع عليه', // Disputed
    waitingIdentification: 'في انتظار المطابقة',
  },
  searchInput: {
    placeholder: 'بحث باسم الحاج أو رقم الجواز...', // Search by pilgrim name or passport number
  },
  statistics: {
    rooms: 'الغرف', // Rooms
    occupiedTotal: 'المشغولة / الكلي', // Occupied / Total
    beds: 'الأسرّة', // Beds
    occupiedCapacity: 'المشغولة / السعة', // Occupied / Capacity
    occupancyRate: 'نسبة الإشغال', // Occupancy Rate
    percentage: 'النسبة المئوية', // Percentage
  },
  actions: {
    viewDetails: 'عرض التفاصيل', // View Details
    download: 'تحميل التسكين', // Download Accommodation
    deleteTable: 'حذف الجدول', // Delete Table
    editRoom: 'تعديل الغرف',
  },
  messages: {
    exportSuccess: 'تم تصدير بيانات التسكين بنجاح', // Accommodation data exported successfully
    exportError: 'فشل في تصدير بيانات التسكين', // Failed to export accommodation data
    deleteSuccess: 'تم حذف جدول التسكين بنجاح', // Accommodation table deleted successfully
    deleteError: 'فشل في حذف جدول التسكين', // Failed to delete accommodation table
  },
  confirmDialog: {
    deleteTitle: 'حذف جدول التسكين', // Delete Accommodation Table
    deleteMessage: 'هل أنت متأكد من حذف جدول "{name}"؟', // Are you sure you want to delete the table "{name}"?
    delete: 'حذف', // Delete
    cancel: 'إلغاء', // Cancel
  },
  roomStats: {
    rooms: 'إحصائيات الغرف', // Room Statistics
    occupiedTotal: 'المشغولة / الكلي', // Occupied / Total
    beds: 'إحصائيات الأسرّة', // Bed Statistics
    occupiedCapacity: 'المشغولة / السعة', // Occupied / Capacity
    guestDistribution: 'توزيع النزلاء', // Guest Distribution
    male: 'ذكور', // Male
    female: 'إناث', // Female
    occupancyRate: 'نسبة الإشغال', // Occupancy Rate
    highOccupancy: 'إشغال مرتفع', // High Occupancy
    mediumOccupancy: 'إشغال متوسط', // Medium Occupancy
    lowOccupancy: 'إشغال منخفض', // Low Occupancy
  },
  roomTable: {
    headers: {
      roomNumber: 'رقم الغرفة',
      roomType: 'نوع الغرفة',
      capacity: 'السعة',
      occupancy: 'الإشغال',
      actions: 'عرض',
    },
    roomTypes: {
      double: 'ثنائية',
      triple: 'ثلاثية',
      quad: 'رباعية',
    },
  },
  roomBulkEditModal: {
    title: 'تعديل الغرف',
    downloadTemplate: 'تحميل نموذج Excel',
    fileLabel: 'ملف Excel',
    cancel: 'إلغاء',
    updating: 'جاري التحديث...',
    updateRooms: 'تحديث الغرف',
    duplicateRoomError: 'رقم الغرفة {roomNumber} مكرر في الصف {row}',
    roomTypeChangeError: 'لا يمكن تغيير نوع الغرفة {roomNumber} لأنها مشغولة',
    successMessage: 'تم تحديث الغرف بنجاح',
    processingError: 'حدث خطأ أثناء معالجة الملف',
    fileReadError: 'فشل في قراءة الملف',
    uploadError: 'حدث خطأ أثناء رفع الملف',
  },
  fileUploadZone: {
    excelFileError: 'يجب اختيار ملف Excel فقط',
    removeFile: 'إزالة الملف',
    chooseFile: 'اختر ملف',
    dragAndDrop: ' أو قم بسحب وإفلات الملف هنا',
    excelOnly: 'Excel فقط',
  },
  warningMessage: {
    title: 'تنبيه مهم',
    message:
      'تأكد من أن الملف يتبع النموذج المطلوب. يجب أن يحتوي على الأعمدة التالية:',
    columns: {
      originalRoomNumber: 'رقم الغرفة الأصلي (original_room_number)',
      roomType: 'نوع الغرفة (room_type): double, triple, أو quadruple',
      editedRoomNumber: 'رقم الغرفة المعدل (edited_room_number)',
    },
    notesTitle: 'ملاحظات:',
    notes: {
      note1: 'ترك رقم الغرفة المعدل فارغاً يعني حذف الغرفة',
      note2:
        'ترك رقم الغرفة الأصلي فارغاً مع تعبئة رقم الغرفة المعدل يعني إضافة غرفة جديدة',
      note3: 'لا يمكن تغيير نوع الغرفة إذا كانت مشغولة بالحجاج',
    },
  },
  roomTableRow: {
    roomTypes: {
      double: 'غرفة مزدوجة',
      triple: 'غرفة ثلاثية',
      quadruple: 'غرفة رباعية',
    },
    capacity: 'السعة',
    statuses: {
      available: 'متاح',
      full: 'مكتمل',
      partial: 'متاح جزئياً',
      availableBed: 'سرير متاح',
    },
    years: 'سنة',
    actions: {
      viewDetails: 'عرض التفاصيل',
    },
  },
  errors: {
    loadRoom: 'فشل في تحميل تفاصيل الغرفة',
    assignPermission: 'ليس لديك صلاحية لتسكين الحجاج',
    removePermission: 'ليس لديك صلاحية لإزالة الحجاج',
    invalidRoomNumber: 'يرجى إدخال رقم غرفة صحيح',
    assignFailed: 'فشل في تسكين الحاج',
    removeFailed: 'فشل في إزالة الحاج',
    updateRoomNumber: 'فشل في تحديث رقم الغرفة',
    emptyComment: 'يجب إدخال نص التعليق',
    notLoggedIn: 'يجب تسجيل الدخول لإضافة تعليق',
    addComment: 'فشل في إضافة التعليق',
    deleteComment: 'فشل في حذف التعليق',
  },
  success: {
    assignPilgrim: 'تم تسكين الحاج بنجاح',
    removePilgrim: 'تم إزالة الحاج بنجاح',
    updateRoomNumber: 'تم تحديث رقم الغرفة بنجاح',
    addComment: 'تم إضافة التعليق بنجاح',
    deleteComment: 'تم حذف التعليق بنجاح',
  },
  roomViewModal: {
    title: 'الغرفة',
    editTitle: 'تعديل رقم الغرفة',
    placeholder: 'أدخل رقم الغرفة الجديد',
    roomType: 'نوع الغرفة',
    double: 'ثنائية',
    triple: 'ثلاثية',
    quadruple: 'رباعية',
    bedsCount: 'عدد الأسرة',
    assignNew: 'تسكين حاج جديد',
  },
  pilgrimCard: {
    bed: 'سرير',
    years: 'سنة',
    checkIn: 'تاريخ الوصول',
    checkOut: 'تاريخ المغادرة',
    remove: 'إزالة التعيين',
    assignNew: 'اسناد حاج جديد',
    guide: 'المرشد',
  },
  commentSection: {
    header: 'التعليقات والملاحظات',
    delete: 'حذف التعليق',
    placeholder: 'اكتب تعليقاً...',
  },
  //
  roomFilters: {
    placeholders: {
      search: 'بحث برقم الغرفة...',
    },
    options: {
      allRoomTypes: 'كل أنواع الغرف',
      double: 'ثنائية',
      triple: 'ثلاثية',
      quadruple: 'رباعية',
      allStatuses: 'كل الحالات',
      occupied: 'مشغولة',
      available: 'متاحة',
      partial: 'مشغولة جزئياً',
      allPackages: 'جميع الباقات',
      allArrivalDates: 'كل التواريخ',
    },
    activeFilters: 'الفلاتر النشطة',
    labels: {
      search: 'بحث',
      roomType: 'نوع الغرفة',
      status: 'الحالة',
    },
  },
  accommodationTasks: {
    header: 'مهمات التسكين',
    subheader: 'متابعة حالة تسكين الحجاج في الفنادق',
    stats: {
      totalPilgrims: 'إجمالي الحجاج',
      accommodated: 'تم التسكين',
      pending: 'قيد الانتظار',
      completionRate: 'نسبة الإنجاز',
    },
    filters: {
      title: 'خيارات التصفية',
    },
    noResults: 'لا يوجد حجاج مطابقين للفلاتر المحددة',
  },
  tasksFilters: {
    searchPlaceholder: 'بحث باسم الحاج أو البلد...',
    gender: {
      all: 'كل الأنواع',
      male: 'ذكر',
      female: 'أنثى',
    },
    status: {
      all: 'كل الحالات',
      completed: 'تم التسكين',
      pending: 'قيد الانتظار',
    },
    activeFilters: 'الفلاتر النشطة:',
    labels: {
      search: 'بحث',
      gender: 'النوع',
      status: 'الحالة',
    },
  },
  accommodationTasksList: {
    headers: {
      pilgrim: 'الحاج',
      package: 'الباقة',
      mainMakkah: 'فندق مكة الأساسي',
      shiftingMakkah: 'فندق مكة الانتقالي',
      madinah: 'فندق المدينة',
    },
    room: 'غرفة',
  },
  common: {
    notSpecified: 'غير محدد',
    notAvailable: 'لا يوجد',
    pilgrims: 'حجاج',
    delete: 'حذف',
    cancel: 'إلغاء',
    loading: 'جاري التحميل...',
    error: 'حدث خطأ أثناء التحميل',
  },
  pagination: {
    page: 'صفحة',
    of: 'من',
  },
  recentPilgrims: {
    title: 'آخر الحجاج المضافين',
    statuses: {
      approved: 'تم الربط',
      disputed: 'متنازع عليه',
      pending: 'قيد الانتظار',
    },
  },
  organizerStats: {
    totalGuides: 'المرشدين',
    totalPilgrims: 'إجمالي الحجاج',
    pendingLinks: 'طلبات الربط',
    disputes: 'النزاعات',
  },
  pilgrimGuideList: {
    noPilgrims: 'لا يوجد حجاج مرتبطين حالياً',
  },
  addGuideModal: {
    title: 'إضافة مرشد جديد',
    requiredFields: 'جميع الحقول مطلوبة',
    successMessage: 'تم إضافة المرشد بنجاح',
    errorMessage: 'حدث خطأ أثناء إضافة المرشد',
    toastError: 'فشل في إضافة المرشد',
  },
  guideForm: {
    labels: {
      name: 'الاسم',
      organizer: 'المنظم',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
    },
    selectOrganizer: 'اختر المنظم',
    errors: {
      name: 'هذا الحقل مطلوب',
      emailRequired: 'هذا الحقل مطلوب',
      invalidEmail: 'البريد الإلكتروني غير صالح',
      passwordRequired: 'هذا الحقل مطلوب',
      passwordLength: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
      passwordMismatch: 'كلمات المرور غير متطابقة',
    },
    submit: 'حفظ',
    loading: 'جاري الحفظ...',
  },
  addPilgrimModal: {
    titleGuide: 'إضافة حاج',
    titleAdminOrganizer: 'ربط حاج بمرشد',
    passportError: 'يرجى إدخال رقم جواز السفر',
    guideError: 'يرجى اختيار المرشد',
    pilgrimNotFound: 'لم يتم العثور على حاج بهذا الرقم',
    guideNotFound: 'المرشد غير موجود',
    unauthorized: 'غير مصرح بهذه العملية',
    success: 'تم إضافة الحاج بنجاح',
    waitingIdentificationSuccess: 'تم إضافة الحاج وفي انتظار المطابقة',
    addButton: 'إضافة',
    addingButton: 'جاري الإضافة...',
    cancelButton: 'إلغاء',
  },
  pilgrimAssignment: {
    errorNoPassport: 'يرجى إدخال رقم جواز السفر',
    errorAssign: 'فشل في تسكين الحاج',
    placeholder: 'أدخل رقم جواز السفر',
    submitLoading: 'جاري التحقق...',
    submit: 'تسكين الحاج',
  },
  passportInput: {
    label: 'رقم جواز السفر',
    requiredMark: '*',
    placeholder: 'أدخل رقم جواز السفر',
    loading: 'جاري التحميل...',
  },
  guideSearch: {
    label: 'المرشد',
    requiredMark: '*',
    placeholder: 'ابحث باسم المرشد أو البريد الإلكتروني...',
    noGuidesFound: 'لا يوجد مرشدين متاحين',
    noMatchingGuides: 'لا يوجد مرشدين مطابقين للبحث',
  },
  hotelVisualizationPage: {
    headerTitle: 'رؤية الفنادق',
    headerSubtitle: 'عرض تفاصيل الفنادق والمباني والغرف',
    hotelSelectionTitle: 'اختر الفندق',
    buildingSelectionTitle: 'اختر المبنى',
  },
  buildingView: {
    floorNavigationTitle: 'الطوابق',
    floorNavigationSubtitle: 'اختر الطابق لعرض تفاصيله',
  },
  hotelFloor: {
    floorLabel: 'الطابق',
  },
  hotelSelector: {
    singleBuilding: 'مبنى واحد',
    multipleBuildings: '{count} مباني',
  },
  guideStats: {
    registeredPilgrims: 'الحجاج المسجلين',
    accommodatedPilgrims: 'تم التسكين',
    pendingPilgrims: 'قيد الانتظار',
    disputes: 'النزاعات',
  },
  bedList: {
    available: 'متاح للتسكين!',
    bed: 'سرير',
    assign: 'تسكين حاج',
  },
};
